import { PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser';
import { defineStore } from 'pinia';
import { User } from '~/api/models';
import Logger from '~/core/logger';

interface MFAData {
    methods: MFAMethods[];
    webauthn?: {
        public_key: PublicKeyCredentialRequestOptionsJSON;
    };
}

export interface UserStore {
    initialized: boolean;
    mfa?: MFAData;
    data?: User;
}

export const useUserStore = defineStore('user', {
    state: (): UserStore => ({
        initialized: false,
        mfa: undefined,
        data: undefined,
    }),

    getters: {
        loggedIn: (state) => !!state.data,
        isInitialized: (state) => state.initialized,
        hasMfa: (state) => !!state.mfa,
        email: (state) => state.data?.email,
        username: (state) => state.data?.username,
    },

    actions: {
        markInitialized() {
            this.initialized = true;
        },

        setMfa(payload?: MFAData) {
            this.mfa = payload;
        },

        set(payload?: User) {
            if (payload) {
                Logger.debug('User', `Authenticated as ${payload.email}.`);
            } else {
                Logger.debug('User', 'Logged out.');
            }

            // Clear MFA when setting user (login/logout)
            this.mfa = undefined;
            this.data = payload;
        },

        update(payload: Record<string, any>) {
            if (this.data) {
                this.data.update(payload);
            }
        },

        logout() {
            this.set(undefined);
        },

        clearMfa() {
            this.mfa = undefined;
        },
    },
});
